<template>
  <hb-report
    :key="report_key"
    report_type="do_not_rent"
    left_slot
    :actions_panel="actions_panel_list"
    show_views
    right_click
    row_click
    show_search
    searchLeftAligned
    :grid-conf="gridConf"
    :column-conf="columnConf"
    @gridReady="onGridReady"
    actionButtonLabel="Add Contact"
    @action-btn-click="addContact"
    isBulkEditPropertyOverride="true"
  ></hb-report>
</template>

<script>
import HbReport from "../assets/HummingbirdReportViewer.vue";
import DoNotRentKebabFilter from "./custom_renderers/DoNotRentKebabFilter.vue";
import ReasonRenderer from "./custom_renderers/ReasonRenderer.vue";
import DoNotRentAddedAtRenderer from "./custom_renderers/DoNotRentAddedAtRenderer.vue";
import { AllModules } from "ag-grid-enterprise";
import { EventBus } from "../../EventBus.js";

export default {
  components: {
    HbReport,
    ReasonRenderer,
    DoNotRentAddedAtRenderer,
  },
  mounted() {
    this.fetchData();
    EventBus.$on("onClickAction", this.onClickAction);
    EventBus.$on("clickReasonButton", this.onClickReason);
    EventBus.$on("clickPhoneButton", this.onClickPhone);
  },
  created() {
    EventBus.$on("doNotRentReportUpdated", this.fetchData);
  },
  destroyed() {
    EventBus.$off("onClickAction");
    EventBus.$off("clickReasonButton");
    EventBus.$off("clickPhoneButton");
    EventBus.$off("doNotRentReportUpdated");
  },
  data() {
    return {
      report_key: 0,
      modules: AllModules,
      gridApi: null,
      defaultColDef: {
        flex: 1,
      },
      columnApi: null,
      rowSelection: "multiple",
      rowData: null,
      isEditActive: "false",
    };
  },
  methods: {
    fetchData() {
      //this.report_key++;
      this.triggerTableRefresh();
    },
    triggerTableRefresh(data = {}, columns = []) {
      if (!this.$route.query.dynamicRun) {
        this.$router.push({ path: "", query: { dynamicRun: true } });
      }
      this.gridApi?.refreshServerSide({ route: columns, purge: true });
    },
    onClickPhone({ data }) {
      console.log("onClickPhone ===>", data);
    },
    onClickReason({ data }) {
      this.$emit("editContact", data);
    },
    async onClickAction({ event, data }) {
      if (event === "remove") {
        const selectedRows = [data];
        this.$emit("selected-rows", selectedRows);
        this.$emit("removeContact");
      }
      if (event === "edit") {
        this.$emit("editContact", data);
      }
    },
    onSelectionChanged() {
      const selectedRows = this.gridApi.getSelectedRows();
      // Emit selected rows to parent
      this.$emit("selected-rows", selectedRows);
    },
    onGridReady(params) {
      this.gridApi = params;
    },
    addContact() {
      this.$emit("addContact");
    },
  },
  computed: {
    actions_panel_list() {
      return ["upload", "bulk_edit", "add_contact"];
    },
    gridConf() {
      return {
        props: {
          ...{
            BIHelpers: {
              kebab: {
                enabled: true,
                icon: "mdi-dots-vertical",
                component: {
                  definition: DoNotRentKebabFilter,
                  props: {
                    parentEvent: "onClickAction",
                  },
                },
                action: "click",
              },
            },
          },
          getRowId: (params) => params.data.contact_id,
          defaultColDef: {
            floatingFilter: false,
            wrapHeaderText: true,
            autoHeaderHeight: true,
          },
        },
      };
    },
    columnConf() {
      return {
        dnr_reason: {
          autoWidth: true,
          cellRenderer: "ReasonRenderer",
          cellRendererParams: {
            event: {
              name: "clickReasonButton",
              method: "onClickReason",
            },
          },
        },
        dnr_added_at: {
          autoWidth: true,
          cellRenderer: "DoNotRentAddedAtRenderer",
          // cellRendererParams: {
          //   event: {
          //     name: "clickReasonButton",
          //     method: "onClickReason",
          //   },
          // },
        },
        tenant_phone_type: {
          hide: true,
        },
        tenant_first: {
          hide: true,
        },
        tenant_last: {
          hide: true,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
